import React, { Component } from "react";
import { connect } from "react-redux";
import { exportComponentAsPDF, exportComponentAsPNG } from "react-component-export-image";
import Measure from "react-measure";

import { Translate } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import ChargerQR from "../../utils/components/ChargerQR";
import RadioCheck from "../../utils/components/RadioCheck";

import "../../../styles/components/chargers/modals/ExportQR.scss";

class ExportQR extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.componentRef = React.createRef();

    this.state = {
      width: 0,
      height: 0,
      selectedStyle: 0,
      selectedFileType: "png",
    };

    this.selectStyle = this.selectStyle.bind(this);
    this.handleOnChangeFileType = this.handleOnChangeFileType.bind(this);
    this.handleOnExport = this.handleOnExport.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  setCanvasSize(bounds) {
    const { width, height } = bounds;
    if (this.state.width !== width || this.state.height !== height)
      this.safeSetState({ width, height });
  }

  selectStyle(style) {
    this.safeSetState({ selectedStyle: style });
  }

  handleOnChangeFileType(e) {
    this.safeSetState({ selectedFileType: e.target.name });
  }

  handleOnExport(e) {
    if (this.state.selectedFileType === "png")
      exportComponentAsPNG(this.componentRef, {
        fileName: `QR_${this.props.selectedCharger.name}_${this.props.qrCodeId}.png`,
        html2CanvasOptions: { backgroundColor: "rgba(0, 0, 0, 0)" },
      });
    else
      exportComponentAsPDF(this.componentRef, {
        fileName: `QR_${this.props.qrCodeId}.pdf`,
        html2CanvasOptions: { backgroundColor: "rgba(0, 0, 0, 0)" },
        pdfOptions: { w: 400, h: 255, unit: "px", pdfFormat: [530, 340] },
      });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="exportQR"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.reset}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontWeight: 700 }}>
              <Translate value="exportQR_export" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="qr-container">
              <div className="qr-style-picker">
                <p>
                  1. <Translate value="exportQR_selectStyle" />
                </p>
                {this.props.brand.icons?.qrcodeIcon.map?.((template, idx) => (
                  <div
                    key={idx}
                    className={
                      this.state.selectedStyle === idx
                        ? `style-${idx + 1} selected`
                        : `style-${idx + 1}`
                    }
                    onClick={() => this.selectStyle(idx)}
                  >
                    <ChargerQR
                      template={template}
                      qrCodeId={this.props.qrCodeId}
                      style={{ width: 200, height: 100, styleType: idx }}
                    />
                  </div>
                ))}
              </div>
              <Measure bounds onResize={contentRect => this.setCanvasSize(contentRect.bounds)}>
                {({ measureRef }) => (
                  <div ref={measureRef} className="qr-code">
                    <p>
                      2. <Translate value="exportQR_selectFileType" />
                    </p>
                    <ChargerQR
                      template={this.props.brand.icons?.qrcodeIcon[this.state.selectedStyle]}
                      qrCodeId={this.props.qrCodeId}
                      style={{
                        width: this.state.width * 0.85,
                        height: this.state.height * 0.85,
                        styleType: this.state.selectedStyle,
                      }}
                    />
                  </div>
                )}
              </Measure>
              <div className="choice-container">
                <RadioCheck
                  label="PNG"
                  labelPos="right"
                  name="png"
                  checked={this.state.selectedFileType === "png"}
                  onChange={this.handleOnChangeFileType}
                />
                <RadioCheck
                  label="PDF"
                  labelPos="right"
                  name="pdf"
                  checked={this.state.selectedFileType === "pdf"}
                  onChange={this.handleOnChangeFileType}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" onClick={this.handleOnExport}>
              <Translate value="exportQR_export" />
            </button>
          </Modal.Footer>
        </Modal>
        <div
          style={{
            width: "1181.102px",
            position: "fixed",
            top: 0,
            zIndex: -1000,
            backgroundColor: "transparent",
            padding: 0,
            margin: 0,
          }}
        >
          <ChargerQR
            ref={this.componentRef}
            template={this.props.brand.icons?.qrcodeIcon[this.state.selectedStyle]}
            qrCodeId={this.props.qrCodeId}
            style={{
              width: 1181.102,
              height: 752.952,
              styleType: this.state.selectedStyle,
            }}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(ExportQR);
